/**
 * Smooth-scroll to an in-page anchor while scroll-snap is on `html`.
 * Mobile browsers often ignore smooth programmatic scroll when snap is mandatory.
 */
export function scrollToAnchor(hash, duration = 800) {
  const id = hash.replace(/^#/, "");
  if (!id) return false;

  const target = document.getElementById(id);
  if (!target) return false;

  const top = target.getBoundingClientRect().top + window.scrollY;
  const html = document.documentElement;
  const prevSnap = html.style.scrollSnapType;

  html.style.scrollSnapType = "none";
  window.scrollTo({ top, behavior: "smooth" });

  window.setTimeout(() => {
    html.style.scrollSnapType = prevSnap;
  }, duration);

  return true;
}

export function handleAnchorClick(event, hash) {
  if (scrollToAnchor(hash)) {
    event.preventDefault();
  }
}
